import React, { forwardRef } from "react";

/**
 * Logo do I.A Recursos Humanos: lupa com três pessoas dentro.
 * - `cor`: cor do desenho. Use verde-água em fundo escuro e
 *   quase-preto em fundo claro.
 * - Um reflexo passa pela lente de vez em quando.
 */
const LupaRH = forwardRef(({ className, style, onClick, title, cor = "#2dd4bf" }, ref) => {
  const id = React.useMemo(() => `lupa${Math.random().toString(36).slice(2, 8)}`, []);
  return (
    <svg
      ref={ref}
      viewBox="0 0 64 64"
      className={className}
      style={style}
      onClick={onClick}
      role="img"
      aria-label="I.A Recursos Humanos"
    >
      {title ? <title>{title}</title> : null}
      <defs>
        <clipPath id={`${id}-lente`}>
          <circle cx="26" cy="26" r="17.5" />
        </clipPath>
        <linearGradient id={`${id}-reflexo`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".55" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* cabo */}
      <line x1="40" y1="40" x2="56.5" y2="56.5" stroke={cor} strokeWidth="8.5" strokeLinecap="round" />
      {/* aro */}
      <circle cx="26" cy="26" r="20" fill="none" stroke={cor} strokeWidth="5" />

      {/* pessoas dentro da lente */}
      <g clipPath={`url(#${id}-lente)`} fill={cor}>
        <g opacity=".8">
          <circle cx="16.5" cy="22" r="3.6" />
          <rect x="11" y="27" width="11" height="16" rx="4.5" />
          <circle cx="35.5" cy="22" r="3.6" />
          <rect x="30" y="27" width="11" height="16" rx="4.5" />
        </g>
        <circle cx="26" cy="19.5" r="4.6" />
        <rect x="19.5" y="25.8" width="13" height="18" rx="5.5" />
        {/* reflexo passando */}
        <rect x="-20" y="0" width="14" height="60" fill={`url(#${id}-reflexo)`} transform="rotate(25 26 26)">
          <animate attributeName="x" values="-20;-20;60" keyTimes="0;.7;1" dur="4s" repeatCount="indefinite" />
        </rect>
      </g>
    </svg>
  );
});

export default LupaRH;
